<template>
    <v-card>
        <v-card-title>
            <div class="title">Cadastro de avaliador de outra instituição</div>
        </v-card-title>
        <v-card-text>
            <v-form ref="form" v-model="valid">
                <div v-if="!submitted">
                    <v-select label="Nacionalidade" v-model="person.nationality" prepend-icon="" :items="nationalities"
                        item-text="name" item-value="id"></v-select>
                    <v-text-field :label="documentLabel" v-model="person.document" prepend-icon="assignment_ind"
                        :rules="rules.document" :mask="documentMask" required validate-on-blur></v-text-field>
                    <v-text-field label="Nome" v-model="person.name" prepend-icon="text_fields" :rules="rules.name"
                        required></v-text-field>
                    <v-text-field label="Data de Nascimento" v-model="person.birthDate" prepend-icon="date_range"
                        :rules="rules.date" mask="##/##/####" required validate-on-blur></v-text-field>
                    <v-text-field label="E-mail" v-model="person.email" prepend-icon="email" :rules="rules.email"
                        required validate-on-blur></v-text-field>
                    <v-text-field label="Instituição do avaliador. SIGLA - NOME" v-model="person.institution"
                        prepend-icon="school" validate-on-blur></v-text-field>
                    <v-flex xs12 class="text-xs-center">
                        <v-btn @click="submit" color="primary" dark large>Cadastrar avaliador</v-btn>
                    </v-flex>
                </div>
                <div v-if="submitted">
                    <v-alert :value="wasCreated" color="success">O avaliador {{ person.name }} ({{ documentLabel }} {{
                        person.document }}) foi cadastrado com sucesso.</v-alert>
                    <v-alert :value="wasUpdated" color="warning">Já existe um usuário cadastrado para o {{ documentLabel
                        }} {{ person.document }}:<br>
                        Código: {{ exists.id }} <br>
                        Nome: {{ exists.name }} <br>
                        Tipo: {{ exists.typeDescription }} <br>
                        E-mail: {{ exists.email }} <br>
                        Permissão para avaliação de bancas: <strong>{{ exists.examinerStatusDescription }}</strong>
                    </v-alert>
                    <v-alert :value="canSendAccess && !accessSent" color="info">Se desejar, clique em <strong>Enviar
                            acesso</strong> para liberar acesso à rede sem fio no período de bancas e enviar código e
                        senha de acesso por e-mail para o avaliador.</v-alert>
                    <v-flex xs12 class="text-xs-center" v-if="canSendAccess && !accessSent">
                        <v-btn @click="sendAccess" color="info" dark large>Enviar acesso</v-btn>
                    </v-flex>
                    <v-alert :value="accessSent" color="success">Um e-mail foi enviado para o avaliador com o código e
                        senha para acesso à rede sem fio e ao Sistema de Gestão de Bancas.</v-alert>
                    <v-flex xs12 class="text-xs-center">
                        <v-btn @click="reset" color="primary" dark large>Cadastrar outro avaliador</v-btn>
                    </v-flex>
                </div>
                <v-alert :value="true" color="error" v-if="error">{{ error }}</v-alert>
            </v-form>
        </v-card-text>
        <v-card-actions v-if="showActions">
            <slot name="actions"></slot>
        </v-card-actions>
    </v-card>
</template>

<script>
import RegisterExternalMixin from './RegisterExternalMixin'

export default {
    name: 'RegisterExternalExaminer',
    mixins: [RegisterExternalMixin],
    data() {
        return {
            submitted: false,
            wasCreated: false,
            wasUpdated: false,
            showActions: false
        }
    },
    methods: {
        submit() {
            this.error = ''
            this.submitted = false
            this.wasCreated = false
            this.wasUpdated = false
            this.canSendAccess = false
            this.accessSent = false
            if (this.valid) {
                this.$http.post('registerExternalExaminer', this.person).then(response => {
                    // console.log(response)
                    if (typeof response.data.status !== 'undefined') {
                        if (response.data.status == 'ok') {
                            this.submitted = true
                            this.wasCreated = true
                            this.canSendAccess = true
                            this.$emit('registered', { id: this.person.document, name: this.person.name, type: '4' })
                        } else if (response.data.status == 'already_exists') {
                            this.submitted = true
                            this.wasUpdated = true
                            this.exists = response.data.user
                            let examinerStatus = 'Inativo'
                            if (this.exists.examinerStatus == 'active') examinerStatus = 'Ativo (não alterado)'
                            if (this.exists.examinerStatus == 'activated') examinerStatus = 'Ativado'
                            this.exists.examinerStatusDescription = examinerStatus
                            if (this.exists.type == '4') {
                                this.canSendAccess = true
                            }
                            if (this.exists.examinerStatus == 'active' || this.exists.examinerStatus == 'activated') {
                                this.$emit('registered', { id: this.exists.id, name: this.exists.name, type: this.exists.type })
                            }
                        } else {
                            this.handleErrors(response.data.errors)
                        }
                    } else {
                        this.handleErrors(response.data.errors)
                    }
                }, response => {
                    this.handleErrors(response.data.errors)
                })
            } else {
                this.error = 'Verifique as informações no formulário e tente novamente.'
            }
        },
        sendAccess() {
            if (!this.canSendAccess || !!!this.person.document) return false
            this.$http.post('notifyExternalExaminer', { document: this.person.document }).then(response => {
                if (typeof response.data.status !== 'undefined' && response.data.status == 'ok') {
                    this.accessSent = true
                } else {
                    this.handleErrors(response.data.errors)
                }
            }, response => {
                this.handleErrors(response.data.errors)
            })
        },
        reset() {
            this.submitted = false
            this.$refs.form.reset()
            var keep = {
                showActions: this.showActions
            }
            Object.assign(this.$data, this.$options.data.apply(this))
            this.$validator.reset()
            this.showActions = keep.showActions
        }
    },
    created: function () {
        this.showActions = typeof this.$slots['actions'] !== 'undefined'
    }

}

</script>


// WEBPACK FOOTER //
// RegisterExternalExaminer.vue?eae991d6